import captureSentryException from '@/features/app/functions/captureSentryException';
import useAxios from '@/shared/hooks/useAxios';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function useMarkNotificationAsReadMutation() {
  const client = useQueryClient();
  const axios = useAxios();

  return useMutation({
    mutationKey: ['markNotificationAsRead'],
    mutationFn: async (id: number) => {
      return axios
        .patch(`/api/v1/notice/${id}`, {
          isNew: false,
        })
        .catch((error) => {
          captureSentryException(error);
          return Promise.reject(error);
        });
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['notification'] });
    },
  });
}
